import { render, staticRenderFns } from "./color.vue?vue&type=template&id=11030104"
import script from "./color.vue?vue&type=script&lang=ts"
export * from "./color.vue?vue&type=script&lang=ts"
import style0 from "./color.vue?vue&type=style&index=0&id=11030104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports